// extracted by mini-css-extract-plugin
export var study__wrap = "study-module--study__wrap--3_5cE";
export var study__banner = "study-module--study__banner--1fp3q";
export var study__studies = "study-module--study__studies--2eIsk";
export var study__studies__study = "study-module--study__studies__study--1AQ3A";
export var study__studies__study__heading = "study-module--study__studies__study__heading--1ckDF";
export var study__sections = "study-module--study__sections--ELPGX";
export var study__section = "study-module--study__section--2bAoe";
export var study__section__image = "study-module--study__section__image--3TJVl";
export var study__section__image__odd = "study-module--study__section__image__odd--QaTfT";
export var info__section__image__bg = "study-module--info__section__image__bg--3yeoP";
export var study__section__image__bg = "study-module--study__section__image__bg--2K6JM";